import styled from 'styled-components'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import { groupBy } from 'lib/array/arrayUtils'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'LuxKit/Typography/Heading'
import VillasPageAmenity from './VillasPageAmenity'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import LoyaltyBenefitInfoIcon from 'loyalty/components/LoyaltyBenefitInfoIcon'

const AmenitiesGrid = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: repeat(2, minmax(0, 280px));
  grid-gap: ${rem(16)};
`

interface Props {
  amenities: Array<App.PackageRoomAmenity>
  loyaltyInclusions?: Array<App.OfferInclusion>
}

function isGeneralAmenityGroupName(name: string): boolean {
  return name.trim().toLowerCase() === 'general'
}

function VillasPageAmenitiesModalContent(props: Props) {
  const intl = useIntl()
  const { amenities, loyaltyInclusions } = props
  const amenitiesByGroup = groupBy(amenities, amenity => amenity.group)

  const hasGeneralGroup = [...amenitiesByGroup.keys()].some(isGeneralAmenityGroupName)
  const showGeneralLoyaltyOnlyBlock = Boolean(loyaltyInclusions?.length) && !hasGeneralGroup

  return (
    <VerticalSpacer gap={40}>
      {showGeneralLoyaltyOnlyBlock && loyaltyInclusions && (
        <VerticalSpacer gap={16} key="general-loyalty-only">
          <Heading variant="heading5">
            {intl.formatMessage({
              id: 'nAXmSgRqyyl0hTiEjLJh',
              defaultMessage: 'General',
              description:
                'Section heading for amenities group when only loyalty inclusions are shown under General',
            })}
          </Heading>
          <AmenitiesGrid>
            {loyaltyInclusions.map((inclusion) => (
              <OfferInclusionItem
                key={inclusion.id}
                inclusion={inclusion}
                endIcon={<LoyaltyBenefitInfoIcon inclusionId={inclusion.id} />}
              />
            ))}
          </AmenitiesGrid>
        </VerticalSpacer>
      )}
      {[...amenitiesByGroup.entries()].map(([groupName, amenities]) => (
        <VerticalSpacer gap={16} key={groupName}>
          <Heading variant="heading5">{groupName}</Heading>
          <AmenitiesGrid>
            {amenities.map((amenity) => (<VillasPageAmenity key={amenity.description} amenity={amenity} />))}
            {isGeneralAmenityGroupName(groupName) && loyaltyInclusions?.map((inclusion) => (
              <OfferInclusionItem
                key={inclusion.id}
                inclusion={inclusion}
                endIcon={<LoyaltyBenefitInfoIcon inclusionId={inclusion.id} />}
              />
            ))}
          </AmenitiesGrid>
        </VerticalSpacer>
      ))}
    </VerticalSpacer>
  )
}

export default VillasPageAmenitiesModalContent
